import {
  KlaviyoProductEvents,
  KlaviyoPurchaseTypes,
} from "../../Common/config/global";
import { doPost, getRequestHeaders } from "../../Common/utils/https";
import { cloudFunctionsUrl } from "../firebase";
const baseUrl = cloudFunctionsUrl;
export const createKlaviyoEmail = async (
  emailAddress: string,
  subscriptionViewed?: string,
  phoneNumber?: string
) => {
  const url = `${baseUrl}klaviyo/createKlaviyoEmail`;
  const headers = await getRequestHeaders();
  return doPost(url, headers, {
    emailAddress,
    subscriptionViewed,
    phoneNumber,
  });
};

export const createKlaviyoPhone = async (
  phoneNumber: string,
  subscriptionViewed?: string,
  emailAddress?: string
) => {
  const url = `${baseUrl}klaviyo/createKlaviyoPhone`;
  const headers = await getRequestHeaders();
  return doPost(url, headers, {
    phoneNumber,
    subscriptionViewed,
    emailAddress,
  });
};

export const pushKlaviyoProductEvent = async (data: {
  orderEvent: KlaviyoProductEvents;
  productId: string;
  productName: string;
  giveawayCode: string;
  emailAddress: string;
  cancelOrDeleteReason?: string;
}) => {
  const url = `${baseUrl}klaviyo/subscription-events`;
  const headers = await getRequestHeaders();
  return doPost(url, headers, {
    ...data,
    cancelOrDeleteReason: data.cancelOrDeleteReason || "",
  });
};

export const pushKlaviyoPurchaseEvent = async (data: {
  orderEvent: KlaviyoProductEvents;
  orderType: KlaviyoPurchaseTypes;
  productId: string;
  value: number;
  productName: string;
  promoCode: string;
  giveawayCode: string;
  emailAddress: string;
  doubleForHalfOffAvailed: boolean;
}) => {
  const url = `${baseUrl}klaviyo/purchase-events`;
  const headers = await getRequestHeaders();
  return doPost(url, headers, { ...data });
};
